module.exports = {"component":"alert","status":"prod","display-name":"Alerts","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/alert","dependencies":[{"component":"container"}],"url-slug":"alerts"}


//////////////////
// WEBPACK FOOTER
// ./components/alert/docs.json
// module id = 151
// module chunks = 0